import { NonFunctionProperties } from "@sinch/types/utility.types";

/**
 * Sends a POST request to a specified URL with the given data.
 * The request is submitted via a dynamically created form and opens the response in a new browser tab.
 *
 * @param {string} url - The target URL to which the POST request will be sent.
 * @param {Record<string, any>} data - An object containing key-value pairs to be sent as form data.
 *                                      Supports nested arrays for including multiple values under the same key.
 * @param {object} formOptions - Form tag options
 */
export const openPost = (
  url: string,
  data: Record<string, any>,
  formOptions: Partial<NonFunctionProperties<HTMLFormElement>> = {}
) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.target = "_blank"; // Open response in a new tab
  Object.entries(formOptions).forEach(([key, value]) => {
    form[key] = value;
  });

  // Add data as hidden input fields
  for (const key in data) {
    if (Object.hasOwn(data, key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach((item) => {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = `${key}[]`;
          hiddenField.value = item;
          form.appendChild(hiddenField);
        });
      } else {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = value;
        form.appendChild(hiddenField);
      }
    }
  }

  // Append the form to the body (required for submission)
  document.body.appendChild(form);

  // Submit the form
  form.submit();

  // Remove the form from the body (optional cleanup)
  document.body.removeChild(form);
};
